import { Server } from 'socket.io';
import { AuthSocket } from '../socket.bootstrap';
import { SocketEvents } from '@ichat/shared-types';
import { setPresence, PRESENCE_TTL } from '../../shared/redis';
import { prisma } from '../../shared/prisma';

export function presenceHandler(io: Server, socket: AuthSocket) {
  // Heartbeat to refresh TTL
  const heartbeat = setInterval(async () => {
    // Only refresh TTL in cache, preserve existing status
    const current = await prisma.user.findUnique({ where: { id: socket.userId }, select: { presence: true } });
    if (current) {
      await setPresence(socket.userId, current.presence || 'online');
    }
  }, (PRESENCE_TTL - 10) * 1000);

  socket.on(SocketEvents.PRESENCE_UPDATE, async ({ presence }: { presence: string }) => {
    try {
      await setPresence(socket.userId, presence);
      await prisma.user.update({ where: { id: socket.userId }, data: { presence: presence as any } });
      io.emit(SocketEvents.PRESENCE_UPDATE, { userId: socket.userId, presence });
    } catch (err) {
      console.error('presence:update error', err);
    }
  });

  socket.on('disconnect', () => {
    clearInterval(heartbeat);
  });
}
